import {
    createHandlerChainRunner,
    Handler,
    HasOnSuccess,
    makeHandlerChainAwaitable,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import loadCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCart";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import addToCart from "@insite/client-framework/Store/Pages/Cart/Handlers/AddToCart";
import { getRockwellConfiguredProductsUsingConfigurationId } from "@tSchaedlerYesco/Services/RockwellConfiguratorService";

export type RockwellConfiguratorRedirectPageParameter = {
    onError?: (error: string) => void;
    configurationId: string;
} & HasOnSuccess<any>;

type HandlerType = Handler<
    {
        getRockwellConfiguredProductsParameter: RockwellConfiguratorRedirectPageParameter;
        onSuccess: (errorMessage: React.ReactNode) => void;
    },
    {
        apiParameter: any;
        apiResult?: any;
        result: any;
    }
>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.getRockwellConfiguredProductsParameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getRockwellConfiguredProductsUsingConfigurationId(
        props.parameter.getRockwellConfiguredProductsParameter.configurationId,
    );
};

export const LoadCart: HandlerType = props => {
    // eslint-disable-next-line no-console
    // console.log("props.apiResult", props.apiResult);
    // if (props.apiResult.result.length > 0) {
    //     props.apiResult.result.forEach(async (element: any) => {
    //         const awaitableLoadCurrentCart = makeHandlerChainAwaitable(
    //             addToCart({
    //                 productId: element.id,
    //                 qtyOrdered: element.minimumOrderQty,
    //                 unitOfMeasure: element.unitOfMeasure,
    //                 notes: element.notes,
    //             }),
    //         );
    //         await awaitableLoadCurrentCart({})(props.dispatch, props.getState);
    //     });
    // }
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    props.parameter.onSuccess?.(props.apiResult);
};
export const chain = [PopulateApiParameter, RequestDataFromApi, ExecuteOnSuccessCallback];

// const getRockwellConfiguredProductsHandler = createHandlerChainRunnerForOldOnComplete(
//     chain,
//     "GetRockwellConfiguredProductsHandler",
// );
const getRockwellConfiguredProductsHandler = createHandlerChainRunner(chain, "GetRockwellConfiguredProductsHandler");
export default getRockwellConfiguredProductsHandler;
